import { mapState } from 'vuex';



export default {
    name: 'wai-summarysymptoms',
    props: {
        symptoms : Array,
        results : Array,
        actual : Boolean
    },

    model : {
        prop : 'results',
        event : 'change'
    },

    data : function(){


        return {
            loading : false, 
            showed : {},
            vis : {}
        }

    },

    created : () => {

    },

    watch: {
        showed : function(){
        }
        //$route: 'getdata'
    },

    beforeRouteEnter (to, from, next) {
        next()
    },

    beforeRouteUpdate (to, from, next) {
        next()
    },

    computed: mapState({
        auth : state => state.auth,

        cuis : function(){

            return _.map(this.symptoms, s=> {
                return s.CUI
            }).join(',')

        },        

        gresults : function(){

            if(this.results){
                var g = this.$f.group(this.results, function(f){
                    return f.STY
                })

                return g
            }

            return null
        },   
        
        categories : function(){

           
            if (this.gresults){

                var categories = _.map(this.gresults, function(r, i){
                    return {
                        name : i,
                        addtosearch : true,
                        id : i
                    }
                })

                categories = _.sortBy(categories, function(c){

                    if(c.name == "Gene or Genome") return 1
                    if(c.name == "Amino Acid, Peptide, or Protein") return 2
                    if(c.name == "Organic Chemical") return 3
                    if(c.name == "Nucleic Acid, Nucleoside, or Nucleotide") return 4
                    if(c.name == "Cell") return 5

                    return 1000

                })


                return categories
            }
        },

        maxminlogs : function(){
            var m = {};

            if(this.gresults){   

                var d = this.gresults

                _.each(this.categories, function(c){

                    var i = c.id

                    if (d[i] && d[i].length){

                        m[i] = {}

                        m[i].max = Math.log10(Number(_.maxBy(d[i], function(d){
                            return Number(d.p)
                        }).p))

                        m[i].min = Math.log10(Number(_.minBy(d[i], function(d){
                            return Number(d.p)
                        }).p))

                        m[i].range = m[i].max - m[i].min
                    }
                })

            }


            return m
        },
        max : function(){

            var m = {};

            if(this.gresults){   

                var d = this.gresults

                _.each(this.categories, function(c){
                    var i = c.id


                    if(d[i]){

                        m[i] = Number(_.maxBy(d[i], function(d){
                            return Number(d.p)
                        }).p)

                    }
                })

            }


            return m

        }
    }),

    methods : {
        visibility : function(isVisible, entry){
            
            if(isVisible){

                var t = this

                var id = entry.target.getAttribute('category');

                this.$set(this.vis, id, true);
              
            }
            
        },
        addtosearch : function(p){
            this.$emit('addtosearch', p)
        },

        removefromsymthoms : function(cui){
            this.results.sym = _.filter(this.results.sym, function(s){
                return s.CUI != cui
            })
        },

        showhide : function(id){
            var value = true

            if (this.showed[id]) value = false

            this.$set(this.showed, id, value);

        },

        show : function(id){
            var value = true

            this.$set(this.vis, id, true);
            this.$set(this.showed, id, value);

        },

        toresult : function(cui){

            var r = _.find(this.results, function(r){
                return r.CUI == cui
            })

            if(!r) return

            var id = r.STY

            this.show(id)

            var s = this.$f.scrollTo

            var t = this

            

            setTimeout(function(){
                var _el = $(t.$el).find('.item[cui="'+cui+'"]')
    
                s(_el)

                _el.addClass('active')

                setTimeout(function(){
                    _el.removeClass('active')
                }, 1300)

            }, 300)
            
        }
       
    },
}